/*
---------------------------------
Module - events-search-results
---------------------------------
*/

import Handlebars from "handlebars/dist/handlebars";

import {hbsHelpers} from 'PlugAndPlay/_global/js/handlebarsHelpers'

import { setCookie } from "PlugAndPlay/_global/js/cookieHelper";

import { MarkerClusterer, SuperClusterAlgorithm } from "@googlemaps/markerclusterer";

import cloneDeep from 'lodash/cloneDeep';

(function () {

    const eventsSearchResults = (function () {

        // Main wrapper and a place to scroll to when pagination occurs updated
        let elResultsWrapper;

        //  Get JSON data of results from an endpoint stored in a data attribute
        let resultsData;

        // This stores the current filtered set
        // Whatever is stored here is used to render the search results
        let resultsProcessed;

        // Wrapper elements
        let elResultsMapWrapper;
        let elResultsListingWrapper;
        let elResultsFeedbackWrapper;

        // Handlebars templates related
        // Current template to use depends on whether the user has used the layout switcher
        // Note that when the user clicks on a layout switcher button, a cookie is created to store the preference
        // data-mode is the current template layout
        let compiledGridTemplate;
        let compiledListTemplate;
        let compiledCardTemplate;
        let compiledNoFilteredResultsMessage; // Store a handlebars generated no filtered message for the scenario where there are no filtered results after filtering

        // Store the current template setting
        let currentTemplate;
        
        // Store checkbox which filters results to show only free events or not based on costType of JSON results
        let freeFilter;

        // Store checked checkboxes which filter results by venue name(s)
        let venueCheckedFilters;

        // Store checked checkboxes which filter results by accessibility options
        let accessibilityCheckedFilters;

        // Pagination related
        let numResultsPerPage;
        let paginationLinks; // Determines how many real links to render
        const paginationLimit = 5; // Define how many page links to ideally display at a time in the pagination component

        let totalResults;
        let totalPages; // Keeps track of total number of pages of results
        let currentPage; // Keeps track of what page number user is on

        // Everytime the pagination is rendered, this represents the page number of the first pagination link based on what current page the user is on
        // e.g. If I'm on page 7, this should be 2
        let firstPage;

        // Keep track of whats the current layout set
        let currentLayout;

        // Store Google map object
        let map;

        // Store Google map markers that will be generated when map is generated
        let mapMarkers = [];

        // Store markerCluster object to handle clustering and rendering of markers on map
        let markerCluster;

        // Compile templates that are stored within script tags
        function setupTemplates() {

            compiledGridTemplate = Handlebars.compile(document.querySelector(".events-search-results__template--grid").innerHTML);

            compiledListTemplate = Handlebars.compile(document.querySelector(".events-search-results__template--list").innerHTML);

            compiledCardTemplate = Handlebars.compile(document.querySelector(".events-search-results__template--card").innerHTML);

            compiledNoFilteredResultsMessage = Handlebars.compile(document.querySelector(".events-search-results__template--no-filtered-results").innerHTML)();

        }

        function mapClicked(event) {

            const target = event.target
            
            // Card links don't work for some reason in infowindow
            // Dynamically add click event
            if (target.closest(".card__link")) {
                
                const link = target.closest(".card__link").getAttribute("href");

                // Redirect to link
                if (link) {
                    window.location.href = link;
                }
                
            }
            
        }

        function setLayout() {

            currentLayout = elResultsWrapper.getAttribute("data-layout");

            if (currentLayout === "grid") {

                numResultsPerPage = 12;

                currentTemplate = compiledGridTemplate;

            } else if (currentLayout === "list") {

                numResultsPerPage = 9;

                currentTemplate = compiledListTemplate;

            } else if (currentLayout === "map") {

                currentTemplate = compiledCardTemplate;

            }

        }

        function renderPagination() {

            let paginationHTML = "";

            if (totalPages > 1) {

                paginationHTML += '<div aria-label="Pagination navigation" class="pagination"><ul class="pagination__list">';

                // Previous page link
                if (currentPage !== 1) {

                    paginationHTML = `${paginationHTML}<li class="pagination__item pagination__item--previous"><button class="pagination__link" aria-label="Previous page of results" data-page=${currentPage - 1}><svg class="svg-icon"><title>Previous page of results</title><use href="#arrow"></use></svg></button></li>`;

                }

                // Page links
                for (let pageNum = firstPage; pageNum < firstPage + paginationLinks; pageNum++) {

                    if (pageNum === currentPage) {
                        paginationHTML = `${paginationHTML}<li class="pagination__item pagination__item--current" aria-current="page"><button class="pagination__link" data-page="${pageNum}" aria-label="Go to Page ${pageNum}">${pageNum}</button></li>`;
                    } else {
                        paginationHTML = `${paginationHTML}<li class="pagination__item"><button class="pagination__link" data-page="${pageNum}" aria-label="Go to Page ${pageNum}">${pageNum}</button></li>`;
                    }

                }

                // Next page link
                if (currentPage !== totalPages) {
                    paginationHTML = `${paginationHTML}<li class="pagination__item pagination__item--next"><button class="pagination__link" aria-label="Next page of results" data-page="${currentPage + 1}"><svg class="svg-icon svg-icon--large"><title>Next page of results</title><use href="#arrow"></use></svg></button></li>`;
                }

                paginationHTML += "</ul></div>";

            }

            return paginationHTML;

        }

        function renderResultsListing() {

            const currentPageResults = resultsProcessed.slice((currentPage - 1) * numResultsPerPage, currentPage * numResultsPerPage);

            let html = currentTemplate(currentPageResults);
    
            html += renderPagination();

            elResultsListingWrapper.innerHTML = html;

            elResultsListingWrapper.classList.remove("hidden");
            elResultsMapWrapper.classList.add("hidden");

        }

        function renderResultsMap() {

            // Before we consider rendering the map, we need to check if there actually any processed results with coordinates
            const processedResultsWithCoordinates = resultsProcessed.filter(obj => obj.venueLatitude && obj.venueLongitude);
            
            if (processedResultsWithCoordinates.length) {

                const originalResultsWithCoordinates = resultsData.filter(obj => obj.venueLatitude && obj.venueLongitude);

                // This controls the max zoom level and ensure that multiple markers at same location stay clustered at max zoom
                const maxZoom = 18;

                // If map hasn't been created yet
                // Create the map and the original results marker object array
                if (!map) {

                    // Initialise the google map 
                    // Note that this counts as a request and will be charged to the Google billing account)
                    // Center on townsville region
                    map = new google.maps.Map(elResultsMapWrapper, {

                        zoom: 11,
                        minZoom: 11,
                        maxZoom: maxZoom,
                        center: {lat: -19.30, lng: 146.8},
                        mapTypeControl: false,
                        fullscreenControl: false,
                        streetViewControl: false,
                        restriction: {
                            latLngBounds: {
                                north: -18.8,
                                south: -19.6,
                                east: 147.5,
                                west: 146,
                            },
                        },

                    })

                    // Initiate Google maps infoWindow object that displays event info when marker is clicked on
                    const infoWindow = new google.maps.InfoWindow();

                    infoWindow.addListener('closeclick', function() {

                        // On click, center map on marker
                        map.setCenter(infoWindow.position); 

                    });

                    // Build the original results markers set - 1:1 relationship
                    originalResultsWithCoordinates.forEach(function(result, index) {
                        
                        let marker = new google.maps.Marker({
                            position: { lat: Number(result.venueLatitude), lng: Number(result.venueLongitude) },
                            title: result.title,
                            id: index
                        });

                        marker.addListener("click", () => {

                            // Use Handlebars to generate card template to put in infoWindow
                            infoWindow.setContent(currentTemplate(result));
                            
                            let centerLat = marker.getPosition().lat() + 0.15;
                            let centerLng = marker.getPosition().lng();

                            map.panTo({lat: centerLat, lng: centerLng});

                            infoWindow.open({
                                anchor: marker,
                                map,
                                shouldFocus: true,
                            });

                        });

                        mapMarkers.push(marker);

                    });

                    // Create MarkerClusterer object to manage cluster of markers
                    markerCluster = new MarkerClusterer({
                        map, 
                        algorithm: new SuperClusterAlgorithm({maxZoom: maxZoom}),
                        onClusterClick: function(event, cluster, map) {
                                                        
                            const clusterPosition = cluster.position;
                            let centerLat = clusterPosition.lat();
                            let centerLng = clusterPosition.lng();

                            // The number of markers in the cluster determines how much to off center vertically when panning 
                            const clusterMarkersCount = cluster.markers.length;

                            if (clusterMarkersCount > 8) {
                                centerLat += 0.1;
                            }

                            map.panTo({lat: centerLat, lng: centerLng}); 
                            let infoWindowContent = `
                                <ul>

                                ${cluster.markers.map(function (marker) {
                                    return `<li class="marker-list-item"><a href="#" class="marker-link" data-marker-id="${marker.id}">${marker.title}</a></li>`
                                }).join("")}
                            
                                </ul>
                            `;

                            infoWindow.setContent(infoWindowContent);

                            infoWindow.open({
                                anchor: cluster.marker,
                                map,
                                shouldFocus: true,
                            });

                        },
                        renderer: { 
                            render: ({ count, position }) => new google.maps.Marker({
                                label: { text: String(count), color: "white", fontSize: "11px" },
                                position,
                                // adjust zIndex to be above other markers
                                zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                            })
                        }
                    
                    });

                    // Bind click event on dynamic marker links
                    elResultsMapWrapper.addEventListener("click", function (event) {

                        event.preventDefault();

                        const thisMarkerLink = event.target.closest(".marker-link");
        
                        if (thisMarkerLink) {
        
                            // Each marker link should contain a data attribute which holds the index of the marker in mapMarkers
                            // Once clicked on, the relevant info window of the clicked marker should display
                            const markerID = thisMarkerLink.getAttribute("data-marker-id");
        
                            new google.maps.event.trigger(mapMarkers[markerID], 'click' );

                        }
        
                    });

                }

                // Add/Remove markers which are/are not related to results in resultsProcessed
                // Go through each object in orignalResultsWithCoordinates and use index to reference to markers
                originalResultsWithCoordinates.forEach(function(result, index) {
                
                    const currentMapMarker = mapMarkers[index];

                    // If I find this same URL in the processedResults
                    if (processedResultsWithCoordinates.find(obj => obj.url === result.url)) {

                        // Add marker to clusterer
                        markerCluster.addMarker(currentMapMarker);

                    } else {

                        // Remove marker from clusterer
                        markerCluster.removeMarker(currentMapMarker);

                    }

                });

                elResultsMapWrapper.classList.remove("hidden");
                
                elResultsMapWrapper.addEventListener("click", mapClicked);
                    
                elResultsListingWrapper.classList.add("hidden");

            } else {

                displayNoFilteredResultsMessage();

            }

        }

        function displayNoFilteredResultsMessage() {

            elResultsFeedbackWrapper.innerHTML = compiledNoFilteredResultsMessage;

            elResultsFeedbackWrapper.classList.remove("hidden");
            elResultsListingWrapper.classList.add("hidden");
            elResultsMapWrapper.classList.add("hidden");

        }

        function render() {
            
            if (resultsProcessed.length) {

                elResultsFeedbackWrapper.classList.add("hidden");

                if (currentLayout === "grid" || currentLayout === "list") {

                    renderResultsListing();

                } else if (currentLayout === "map") {
        
                    renderResultsMap();

                }

            } else {

                displayNoFilteredResultsMessage();

            }

        }

        function calculatePagination() {

            totalResults = resultsProcessed.length;

            totalPages = Math.ceil(totalResults / numResultsPerPage);

            if (totalPages < paginationLimit) {
                paginationLinks = totalPages;
            } else if (currentPage > totalPages - Math.floor(paginationLimit / 2)) {
                firstPage = totalPages - (paginationLimit - 1);
            } else if (currentPage > Math.floor(paginationLimit / 2)) {
                firstPage = currentPage - Math.floor(paginationLimit / 2);
            } else {
                firstPage = 1;
            }

        }

        function resetPagination() {

            currentPage = 1;

            firstPage = 1;

            paginationLinks = paginationLimit;

            calculatePagination();

        }

        function setupPagination() {

            elResultsListingWrapper.addEventListener("click", function (event) {

                const thisPaginationLink = event.target.closest(".pagination__link");

                if (thisPaginationLink) {

                    // Each pagination link should contain a data attribtue called page which holds a page number
                    // Once clicked on, thats the new current page
                    currentPage = Number(thisPaginationLink.getAttribute("data-page"));

                    // Re-render results and pagination
                    calculatePagination();

                    render();

                    // Scroll to top of results
                    elResultsWrapper.scrollIntoView();

                }

            });

        }

        // Setup the Layout Switcher component
        // Component is hidden by hidden class on page load
        // Switcher has buttons which clicked, will display the results in different formats
        // Once setup, reveal component
        function setupLayoutSwitcher() {

            const elLayoutSwitcher = document.querySelector(".events-search-results__layout-switcher");

            const buttonClass = "events-search-results__layout-switcher-btn";

            const buttonActiveClass = "events-search-results__layout-switcher-btn--active";

            const elLayoutSwitcherBtns = elLayoutSwitcher.querySelectorAll(`.${buttonClass}`);

            elLayoutSwitcherBtns.forEach((layoutSwitcherBtn) => {

                layoutSwitcherBtn.addEventListener("click", (event) => {
                    
                    let thisLayoutSwitcherBtn = event.target.closest(`.${buttonClass}`);

                    if (thisLayoutSwitcherBtn && !thisLayoutSwitcherBtn.classList.contains(buttonActiveClass)) {
                        
                        document.querySelector(`.${buttonActiveClass}`).classList.remove(buttonActiveClass);

                        thisLayoutSwitcherBtn.classList.add(buttonActiveClass);

                        let selectedMode = thisLayoutSwitcherBtn.getAttribute("data-mode");

                        elResultsWrapper.setAttribute("data-layout", selectedMode);

                        //Store preference as cookie to remember for future searches
                        setCookie("event-search-results-layout", selectedMode, 30);

                        setLayout();

                        resetPagination();

                        render();

                    }

                });

            });

        }

        function filterResults() {

            // Filter the results
            // If no results are available, the no message error from the Handelbars templates in Matrix are displayed

            // Everytime we are filtering, we start with the original results first
            resultsProcessed = cloneDeep(resultsData);

            // Filter results by free filter
            // Checks against "costType": "free"
            // Remember to always check if it exists (e.g. on Ticketshop, this doesn't exist)
            if (freeFilter && freeFilter.checked) {

                resultsProcessed = resultsProcessed.filter(function(event) {

                    if (event.hasOwnProperty("costType") && (event.costType.toLowerCase() == "free") ) {
                        return true;
                    }

                });

            }
            
            // If there are still results
            // Check against "venueName"
            if (resultsProcessed.length && venueCheckedFilters && venueCheckedFilters.length) {

                // Get checked values to filter against
                const checkedValues = venueCheckedFilters.map(checkboxFilter => checkboxFilter.value);

                resultsProcessed = resultsProcessed.filter(event => {

                    if (event.hasOwnProperty("venueName") && event.venueName) {

                        if (checkedValues.includes(event.venueName)) {
                            return true;
                        }

                    } else {

                        // This record doesn't have a venueName or venueName is blank, see if "Other" filter has been selected
                        if (checkedValues.includes("Other")) {
                            return true;
                        }

                    }

                });
          
            }

            // If there are still results
            // Check against "accessibility"
            if (resultsProcessed.length && accessibilityCheckedFilters && accessibilityCheckedFilters.length) {

                // Get checked values to filter against
                const checkedValues =  accessibilityCheckedFilters.map(checkboxFilter => checkboxFilter.value);

                resultsProcessed = resultsProcessed.filter(event => {

                    if (event.hasOwnProperty("accessibility") && event.accessibility.length) {
                        
                        // Intersect the checked values array with the events accessibility property array and see if they have common values
                        const intersection = event.accessibility.filter(option => checkedValues.includes(option));

                        if (intersection.length) {
                            return true;
                        }

                    }
                    
                });

            }
            
            // More potential filters in the future...

            // After filtering, we should go back to page 1
            resetPagination();

            // Render the new search results table
            render();

        }

        function setupFreeFilter() {

            freeFilter = document.getElementById("free-filter");

            if (freeFilter) {

                freeFilter.addEventListener("change", function() {

                    filterResults();

                });

                freeFilter.disabled = false;

            }

        }

        function setupVenueFilter() {

            const wrapper = document.querySelector(".events-search-results__venue-filter");

            if (wrapper) {

                const button = wrapper.querySelector(".list-box__button");
                const buttonDefaultLabel = button.textContent;

                // The available venues will be placed in here
                const dropdown = wrapper.querySelector(".list-box__dropdown");

                // Generate the available venue checkboxes
                const options = [...new Set(resultsData.map(item => item.venueName ? item.venueName : "Other"))];

                // Sort the options
                options.sort((a, b) => { 
                    return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
                });

                // Move "Other" to the end
                if (options.includes("Other")) {
                    options.push(options.splice(options.indexOf("Other"), 1)[0]);
                }

                if (options.length) {
                    
                    let listItemHTML = "";

                    options.forEach((option, index) => {

                        listItemHTML += `<li class="list-box__item">
                            <input
                                type="checkbox"
                                name="venue-filter"
                                id="venue-${index}"
                                value="${option}"
                            />
                            <label for="venue-${index}">${option}</label>
                        </li>`;

                    });

                    dropdown.insertAdjacentHTML("afterbegin", listItemHTML);

                    const checkboxFilters = document.querySelectorAll("[name='venue-filter']");

                    if (checkboxFilters.length) {

                        checkboxFilters.forEach(filter => {

                            // Bind change event listener
                            filter.addEventListener("change", function() {

                                // Set how many have been checked
                                venueCheckedFilters = [...checkboxFilters].filter(checkboxFilter => checkboxFilter.checked);

                                // Update label
                                if (venueCheckedFilters.length) {

                                    button.textContent = `${venueCheckedFilters.length} venue${venueCheckedFilters.length > 1 ? "s" : ""} selected`;

                                } else {

                                    button.textContent = buttonDefaultLabel;

                                }
                                
                                filterResults();

                            });

                        });

                    }

                    button.disabled = false;

                } else {

                    // In case there are no options, just remove from DOM
                    wrapper.remove();

                }

            }

        }

        function setupAccessibilityFilter() {

            const wrapper = document.querySelector(".events-search-results__accessibility-filter");

            if (wrapper) {

                const button = wrapper.querySelector(".list-box__button");
                const buttonDefaultLabel = button.textContent;

                // The available accessibility options will be placed in here
                const dropdown = wrapper.querySelector(".list-box__dropdown");

                // Generate the available accessibility checkboxes
                let options = [];

                resultsData.forEach(item => {

                    if (item.accessibility && item.accessibility.length) {
                        
                        options = options.concat(item.accessibility);
                        
                    }

                });
                

                // Dedupe by using Set - Convert {} into [] with spread operator
                options = [...new Set(options)];

                // Sort the options
                options.sort((a, b) => { 
                    return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
                });

                if (options.length) {
                    
                    let listItemHTML = "";

                    options.forEach((option, index) => {

                        listItemHTML += `<li class="list-box__item">
                            <input
                                type="checkbox"
                                name="accessibility-filter"
                                id="accessibility-${index}"
                                value="${option}"
                            />
                            <label for="accessibility-${index}">${option}</label>
                        </li>`;

                    });

                    dropdown.insertAdjacentHTML("afterbegin", listItemHTML);

                    const checkboxFilters = document.querySelectorAll("[name='accessibility-filter']");

                    if (checkboxFilters.length) {

                        checkboxFilters.forEach(filter => {

                            // Bind change event listener
                            filter.addEventListener("change", function() {

                                // Set how many have been checked
                                accessibilityCheckedFilters = [...checkboxFilters].filter(checkboxFilter => checkboxFilter.checked);

                                // Update label
                                if (accessibilityCheckedFilters.length) {

                                    button.textContent = `${accessibilityCheckedFilters.length} option${accessibilityCheckedFilters.length > 1 ? "s" : ""} selected`;

                                } else {

                                    button.textContent = buttonDefaultLabel;

                                }
                                
                                filterResults();

                            });

                        });

                    }

                    button.disabled = false;

                } else {

                    // In case there are no options, just remove from DOM
                    wrapper.remove();

                }

            }


        }

        function processResultsData() {

            if (resultsData.length) {

                // Initiate handelbars helpers
                hbsHelpers();

                // Make a copy of the original results
                resultsProcessed = cloneDeep(resultsData);

                // Compile the templates with handlebars
                setupTemplates();

                // Setup the pagination link clicks
                setupPagination();

                // Set current layout
                setLayout();

                // Reset pagination related variables (Start on page 1)
                resetPagination();

                // Render the search results table
                render();

                // Setup layout switcher component
                setupLayoutSwitcher();

                // Setup the free cost type filter
                setupFreeFilter();

                // Setup the venue filter
                setupVenueFilter();

                // Setup the accessibility options filter
                setupAccessibilityFilter();

                // Remove hidden class to reveal utility bar which contains free cost type filter and layout switcher component
                document.querySelector(".events-search-results__utility").classList.remove("hidden");

            } else {

                // Append no results found message
                outputNoResultsMessage();

            }

        }

        function outputNoResultsMessage() {

            let compiledNoResultsTemplate = Handlebars.compile(document.querySelector(".events-search-results__template--no-results").innerHTML);;

            elResultsListingWrapper.innerHTML = compiledNoResultsTemplate();

        }

        // Ajax JSON search results data from an endpoint stored in a data attribute
        function getResultsData() {

            let resultsEndpoint = elResultsWrapper.getAttribute("data-results");

            let xhr = new XMLHttpRequest();

            xhr.open("GET", resultsEndpoint, true);

            xhr.onload = function() {

                resultsData = JSON.parse(xhr.response);

                processResultsData();

            }

            xhr.send();
            
        }

        function init() {

            try {

                elResultsWrapper = document.querySelector(".events-search-results");

                elResultsListingWrapper = document.querySelector(".events-search-results__listing");

                elResultsMapWrapper = document.querySelector(".events-search-results__map");

                elResultsFeedbackWrapper = document.querySelector(".events-search-results__feedback");

                if (elResultsWrapper && elResultsListingWrapper && elResultsMapWrapper && elResultsFeedbackWrapper) {

                    // Ajax search results JSON data
                    getResultsData();

                }

            } catch (error) {
                console.error(error);
            }

        }

        return {
            init: init
        };

    })();

    document.addEventListener("DOMContentLoaded", function () {
        eventsSearchResults.init();
    });

})();
